export default "__VITE_ASSET__DBfuXfIo__"